import React, { useEffect, useMemo, useState } from 'react';
import { Card, Col, Row, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { WalletDone02Icon, MessageMultiple01Icon } from 'hugeicons-react';
import { apiFetch } from 'services/apiClient';
import { hasRole, openNotification } from '../../utils';
import ReminderSummaryCards from '../../components/Reminders/ReminderSummaryCards';

const { Title, Text } = Typography;

const extractTotal = (response: any): number => {
  if (!response || typeof response !== 'object') {
    return 0;
  }
  if (typeof response.totalElements === 'number') {
    return response.totalElements;
  }
  if (Array.isArray(response.content)) {
    return response.content.length;
  }
  if (Array.isArray(response)) {
    return response.length;
  }
  return 0;
};

const FinanceDashboard: React.FC = () => {
  const isFinance = useMemo(() => hasRole('FINANCE'), []);
  const isCustomer = useMemo(() => hasRole('CUSTOMER'), []);
  const [plannedPaymentCount, setPlannedPaymentCount] = useState<number | null>(null);
  const [openTicketCount, setOpenTicketCount] = useState<number | null>(null);

  useEffect(() => {
    if (!isFinance) {
      return;
    }
    let ignore = false;

    const fetchMetrics = async () => {
      try {
        const plannedParams = new URLSearchParams({
          page: '0',
          size: '10',
          accountId: '',
          companyId: '',
          company: '',
          city: '',
          district: '',
          statuIds: '4',
          isPaid: 'false',
          sort: 'invoiceDate',
          onlyPartner: 'true',
          direction: 'ASC',
        });
        const plannedResponse = await apiFetch(`/proposals?${plannedParams.toString()}`);
        if (!ignore) {
          setPlannedPaymentCount(extractTotal(plannedResponse));
        }

        const ticketParams = new URLSearchParams({
          'status.equals': 'OPEN',
        });
        const ticketResponse = await apiFetch(`/accounts/me/tickets?${ticketParams.toString()}`);
        if (!ignore) {
          setOpenTicketCount(extractTotal(ticketResponse));
        }
      } catch (error) {
        console.error('Finans dashboard verileri alınamadı:', error);
        openNotification('error', 'Hata', 'Finans metrikleri alınırken bir sorun oluştu.');
        if (!ignore) {
          setPlannedPaymentCount(0);
          setOpenTicketCount(0);
        }
      }
    };

    fetchMetrics();
    return () => {
      ignore = true;
    };
  }, [isFinance]);


  if (!isFinance) {
    return (
      <div style={{ padding: 24 }}>
        <Title level={3}>Yetkisiz Erişim</Title>
        <Text>Bu sayfayı görüntülemek için gerekli yetkiye sahip değilsiniz.</Text>
      </div>
    );
  }

  return (
    <div style={{ padding: 24, minHeight: '90%', paddingTop: 0 }}>
      <Space direction='vertical' size={16} style={{ width: '100%' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} lg={8}>
            <Link to='/payments' style={{ display: 'block' }}>
              <Card bordered={false} hoverable className="dashboard-card dashboard-card-bg-dark" bodyStyle={{ padding: 10 }}>
                <div className='dashboard-container'>
                  <Row justify='space-between' align='middle'>
                    <div className='card-value'>
                      {plannedPaymentCount !== null ? plannedPaymentCount : 0}
                    </div>
                    <WalletDone02Icon size={32} color='white' />
                  </Row>
                  <div>
                    <Title style={{ fontWeight: 'bold', color: "white" }} className='mb-0' level={3}>Ödemesi Planlanmış Projeler</Title>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Link to='/tickets' style={{ display: 'block' }}>
              <Card bordered={false} hoverable className="dashboard-card dashboard-card-bg-purple" bodyStyle={{ padding: 10 }}>
                <div className='dashboard-container'>
                  <Row justify='space-between' align='middle'>
                    <div className='card-value'>
                      {openTicketCount !== null ? openTicketCount : 0}
                    </div>
                    <MessageMultiple01Icon size={32} color='000000e0' />
                  </Row>
                  <div>
                    <Title style={{ fontWeight: 'bold' }} className='mb-0' level={3}>Açık Destek Talepleri</Title>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
        </Row>

        {!isCustomer && (
          <Row gutter={[16, 16]}>
            <Col xs={24} md={24} lg={24}>
              <ReminderSummaryCards
                title="Beklemede Olan Görevler"
                mode="me"
              />
            </Col>
          </Row>
        )}
      </Space>
    </div>
  );
};

export default FinanceDashboard;
